module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hres6ju-popup",
      "id": "hres6ju-popup",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRES6JUC4']['10']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6 input-half-left"
  }, [_c('div', {
    staticClass: "form-group "
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRESH6XC1']['10']) + " :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descCodemid),
      expression: "descCodemid"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "id": "coddesc_codempid",
      "name": "coddesc_codempid",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.descCodemid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descCodemid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-5 input-half-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRESH6XC1']['20']) + " :")]), _vm._v(" "), _c('hrms-dropdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.arrCodtparg[_vm.nowLang],
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codtparg",
      "has-error": _vm.errors.has('codtparg')
    },
    model: {
      value: (_vm.codtparg),
      callback: function($$v) {
        _vm.codtparg = $$v
      },
      expression: "codtparg"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codtparg')),
      expression: "errors.has('codtparg')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codtparg')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group-button"
  }, [_c('div', {
    staticClass: "btn button-in-search bg-color-skin",
    on: {
      "click": function($event) {
        _vm.validatePopupApprove()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.labelsButton['search']))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    attrs: {
      "id": "accordion_popup"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion_popup",
      "href": "#detail1_1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRESH6XC1']['30']) + "\n\t\t\t\t          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "detail1_1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.tab1PopupTable1,
      "data": _vm.popupTab1.table1,
      "maxRowspan": _vm.maxRowspanPopupTable1
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion_popup",
      "href": "#detail1_2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRESH6XC2']['10']) + "\n\t\t\t\t          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "detail1_2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.tab1PopupTable2,
      "data": _vm.popupTab1.table2
    }
  })], 1)])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dc59cb82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6ju/popup.vue
// module id = 3993
// module chunks = 1